import styled from "styled-components";
const DuverifyPageDisplay = styled.div`
// background-image: linear-gradient(to bottom left,#101c03 0,#373736 100%);  background-size: cover;
background: ${p => p.bgImg};
background-size: cover;
margin-top: -5px;
  .formsLayoutjawal
  {
    min-height: 114vh;
  }
  .formsLayoutduverify
  {
    min-height: 100vh;
    // background-image: linear-gradient(to bottom left,#101c03 0,#373736 100%);
    // background-size: cover;
    // margin : 0!important;
    justify-content: center;

  }
  .gamezoneSignup
  {
    background: rgb(238 90 17);
  }
  .header_gamezone
  {
    margin-top: 5px!important;
    width: 100%;
    border-bottom: 2px solid #65378b;
  }
  .links-Section{
    position: absolute;
    //border: 1px solid red;

      top: 30%;
  }
  .links-Sectionjawwalgamezorid
  {
    top: 9%!important;
    width: 75%;
  
    input
    {
      margin-top: 10px;
    }
    .gamezoneInput
    {
      background: white;
      color: black;
      padding: 1px 8px;
    }
    .btnmondia
    {
      text-transform: uppercase;
    width: 80%;
    font-size: 1.2em;
    background-color: #8ce6e6;
    line-height: 2.5em;
    border: 2px solid #528383;
    border-radius: 5em;
    font-weight: 700;
    margin: 8px auto !important;
    }
    
  }

  .links-SectionMondia
  {
    top: 0%!important;
    width: 40%;
    height: 100%;
    background-color: #fff;
    background-image: linear-gradient(to bottom left,#101c03 0,#373736 100%);
   

  }
 
  
 
  .links-Section a {
    color:white
  }
  .links-Section button{
    margin-bottom: 15px;
    display:block;
  }
  .links-Sectionjawwalgamezorid button{
    display: block;
    margin: 30px auto;
    min-width: 190px;
  }
  .formsLayout {
    margin: 0 20px;
    .mondiaFooter
    {
      p , h3
      {
        font-family: duCo_Headline16_iOS_Lt;
         margin: 0;
         color: #dadada;

      }
      h4
      {
        font: inherit;
    color: #dadada;
      }
    }
    .verfiySection
    {
      top: 26%!important;
    width: 61%;
    position: absolute;
    }
    .gamezoneLogo
    {
      max-width: 163px!important;
    }
    .inputs {
      select {
        width: 35%;
        height: 43px;
      }
      input {
        width: 50%;
      }
    .footer{
      .ncellTos {
        font-size: 13px;
        margin-top: 20px;
        display:flex;
        flex-direction:column;
      }

    }

    .mondiancellTos
    {
      h3 , p
      {
        color: #dadada;
      }
    }

  

   
  }
`; export default DuverifyPageDisplay;
